import { render, staticRenderFns } from "./RosterAccess.vue?vue&type=template&id=2111b456"
import script from "./RosterAccess.vue?vue&type=script&lang=js"
export * from "./RosterAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports